if (!customElements.get('mobile-menu')) {
  class MobileMenu extends HTMLElement {
    constructor() {
      super();

      // Store Locator Button Logic
      this.storeLocatorBtn = this.querySelector('[announcement-store-locator]');

      if (this.storeLocatorBtn) {
        this.storeLocatorBtn.addEventListener('click', () => {
          const store_locator = document.querySelector('store-locator-drawer');

          if (store_locator) {
            store_locator.setAttribute('drawer-open', '');

            setTimeout(() => {
              store_locator.classList.add('drawer-open');
            }, 500);
          }
        });
      }

      // Accordion open/close
      this.detailsElements = this.querySelectorAll('details');

      this.detailsElements.forEach((details) => {
        details.addEventListener('click', (e) => {
          if (
            e.target.tagName === 'A' ||
            e.target.closest('a')
          ) {
            return;
          }

          e.preventDefault();

          if (details.hasAttribute('open')) {
            details.removeAttribute('open');
            return;
          }

          this.detailsElements.forEach((item) => {
            item.removeAttribute('open');
          });

          details.setAttribute('open', '');
        });
      });

      // Mobile Menu Tabs
      this.initMobileMenuTabs();
    }

    initMobileMenuTabs() {
      const tabs = this.querySelectorAll('[data-category-tab]');
      const contents = this.querySelectorAll('[data-category-content]');

      if (!tabs.length || !contents.length) {
        return;
      }

      // Make sure only ONE tab/content is active on initial load
      tabs.forEach((tab) => {
        tab.classList.remove('active');
      });

      contents.forEach((content) => {
        content.classList.remove('active');
      });

      // Menu is the default tab
      const defaultTab = this.querySelector(
        '[data-category-tab="menu"]'
      );

      const defaultContent = this.querySelector(
        '[data-category-content="menu"]'
      );

      if (defaultTab) {
        defaultTab.classList.add('active');
      }

      if (defaultContent) {
        defaultContent.classList.add('active');
      }

      // Tab click
      tabs.forEach((tab) => {
        tab.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();

          const target = tab.getAttribute('data-category-tab');

          if (!target) {
            return;
          }

          // Remove active from ALL tabs
          tabs.forEach((item) => {
            item.classList.remove('active');
          });

          // Remove active from ALL contents
          contents.forEach((content) => {
            content.classList.remove('active');
          });

          // Activate clicked tab
          tab.classList.add('active');

          // Activate ONLY matching content
          const targetContent = this.querySelector(
            `[data-category-content="${target}"]`
          );

          if (targetContent) {
            targetContent.classList.add('active');
          }
        });
      });
    }
  }

  customElements.define('mobile-menu', MobileMenu);
}